/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'shared'
import { handleAsyncRequest, shortenRaceNameV2 } from 'utils/helper'
import { useTranslation } from 'react-i18next'
import UserInfoModalStyled from './styled'
import { AVATAR_DEFAULT, CLOSE_BTN, IFRAME_ITEM } from 'assets/images'
import { Spin } from 'antd'
import { PROFILE_MESSAGE } from 'i18n/constants'
import raceApi from 'apis/raceApi'
import { UserInformationResponse } from 'models'
import { convertShortDay } from 'utils/time'
import { useAppSelector } from 'hooks'
import { NUMBER } from 'apps/constants'

interface UserInfoModalProps {
  onCloseButtonClick: () => void
}

function UserInfoModal({ onCloseButtonClick }: UserInfoModalProps) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)
  const handleBackModalCancel = () => {
    onCloseButtonClick()
  }
  const [userInfo, setUserInfo] = useState<UserInformationResponse | undefined>(undefined)
  const { profile } = useAppSelector(state => state)

  useEffect(() => {
    if (profile?.userId) {
      const fetchUserInfo = async () => {
        const [error, result]: any = await handleAsyncRequest(raceApi.getUserInfo(profile?.userId))
        if (error) {
          setIsLoading(false)
          return
        }
        if (result) {
          const data = result.data
          setUserInfo(data)
          setIsLoading(false)
        }
      }
      fetchUserInfo()
    }
  }, [profile?.userId])

  const winRate = useMemo(() => {
    const first = ((Number(userInfo?.first_count) / Number(userInfo?.total_race || 1)) * 100).toFixed(2)
    const second = (
      ((Number(userInfo?.first_count) + Number(userInfo?.second_count) + Number(userInfo?.third_count)) /
        Number(userInfo?.total_race || 1)) *
      100
    ).toFixed(2)
    return {
      first,
      second
    }
  }, [userInfo])

  return (
    <Modal>
      <UserInfoModalStyled>
        <div className='choose-horse-modal modal-select-item'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={handleBackModalCancel}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          {isLoading ? (
            <span className='btn-name d-flex align-items-center justify-content-center'>
              {isLoading && <Spin size='large' className='mt-2 mr-3' />}
            </span>
          ) : (
            <div className='infomation-container'>
              <h4>{t(`${PROFILE_MESSAGE}.userInfo`)}</h4>
              <div className='iframe'>
                <img src={IFRAME_ITEM} alt='' />
              </div>
              <div className='section-information'>
                <img
                  className='user-avatar'
                  width='150px'
                  height='150px'
                  alt='user-avatar'
                  src={userInfo?.avatar || AVATAR_DEFAULT}
                />
                <div className='user-information'>
                  <div>
                    {userInfo?.guild_id && <span className='color-yellow'>{`[${userInfo?.guild_tag}] `}</span>}
                    <span>{shortenRaceNameV2(userInfo?.name, 20)}</span>
                  </div>
                  <div className='d-flex'>
                    <div className='text-title'>Total Horse: </div>
                    <span>{userInfo?.total_horse ?? 0}</span>
                  </div>
                  <div className='d-flex'>
                    <div className='text-title'>Career: </div>
                    <span>
                      {userInfo?.total_race ?? 0} {userInfo?.first_count ?? 0}/{userInfo?.second_count ?? 0}/
                      {userInfo?.third_count ?? 0}
                    </span>
                  </div>
                  <div className='d-flex'>
                    <div className='text-title'>Win Rate: </div>
                    <span>
                      {winRate.first || 0}% - {winRate.second || 0}%
                    </span>
                  </div>
                  <div className='d-flex'>
                    <div className='text-title'>Join Date: </div>
                    <span>{convertShortDay(Number(userInfo?.joining_date) * NUMBER.THOUSAND)}</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </UserInfoModalStyled>
    </Modal>
  )
}

export default UserInfoModal
